// extracted by mini-css-extract-plugin
export var banner = "_h0-0";
export var closeButton = "_h0-2";
export var greenCheckmark = "_h0-3";
export var hereLink = "_h0-4";
export var titleIcon = "_h0-1";